import moment from 'moment';

export default function (value) {
  if (!value) return '';
  return moment(value).fromNow();
}



// WEBPACK FOOTER //
// ./src/filters/relativeTime.js